import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, input, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonModule } from '../button/button.module'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { ModalService } from 'src/app/core/services/modal.service'
import { EventService } from 'src/app/core/services/event.service'
import { ComparisonCardComponent } from '../comparison-card/comparison-card.component'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { ComparisonService } from 'src/app/core/services/comparison.service'
import { IconButtonModule } from '../icon-button/icon-button.module'
import { MatIconModule } from '@angular/material/icon'
import { ColorSchemeDirective } from 'src/app/core/directives/color-scheme.directive'

@Component({
  selector: 'app-comparison-banner',
  templateUrl: './comparison-banner.component.html',
  styleUrls: ['./comparison-banner.component.scss'],
  imports: [
    CommonModule,
    ButtonModule,
    IconButtonModule,
    ComparisonCardComponent,
    MatIconModule,
    ColorSchemeDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComparisonBannerComponent implements AfterViewInit {
  protected globalDataService = inject(GlobalDataService)
  protected comparisonService = inject(ComparisonService)
  protected modalService = inject(ModalService)
  private _eventService = inject(EventService)

  @ViewChild('swiperContainer') swiperContainer!: ElementRef

  assets = input<IAsset[]>([])
  carouselId = input<string>('comparison-carousel')

  ngAfterViewInit() {
    this.swiperInit()
  }

  swiperInit() {
    const assets = this.assets() ?? []
    if (!assets || !assets.length) {
      return
    }

    const swiperContainerParams = {
      slidesPerView: 'auto',
      speed: 500,
      loop: false,
      spaceBetween: 24,
      keyboard: {
        enabled: false,
      },
      navigation: {
        nextEl: `.${this.carouselId()}-next`,
        prevEl: `.${this.carouselId()}-prev`,
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
        }
      }
    }
    Object.assign(this.swiperContainer.nativeElement, swiperContainerParams)
    this.swiperContainer.nativeElement.initialize()
  }

  compare() {
    if (this.comparisonService.assets().length < 1) {
      return
    }
    // No need to await since we don't need the return value
    this.modalService.comparison({})
  }

  clearAll() {
    this._eventService.notifyClearAllComparisonAssets()
  }

  clearAsset(asset: IAsset) {
    this._eventService.notifyClearComparisonAsset(asset.equipment_number)
  }
}
